export default {"src":"/_next/static/media/arrow-diagonal-thick-down.d78e5641.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};